import depTZ from './ensure-timezone-deprecated.json';

export default function ensureTimezone(tz) {
  return depTZ[tz] || tz;
}
